/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoCompra from 'src/components/InfoCompra';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import useCustomToast from 'src/hooks/useCustomToast';
import { UrlBase } from 'src/parametros';
import { guardarLead, notificarFinCompra, POST } from 'src/services';
import {
  urlActualizarEstadoFirma,
  urlGenerarOtraCotizacion,
  urlIngresarPoliza,
} from 'src/services/urls';
import useQueryString from 'src/hooks/useQueryString';

import { useHistory } from 'react-router';
import './styles.css';
import { OPCIONES_PAGO } from 'src/reducers/Cotizacion/cotizacion.reducer';

const NewFinCompra = ({ cotizacion, idCotizacion }) => {
  const history = useHistory();
  const qParams = useQueryString();
  const { addWarningToast, addErrorToast } = useCustomToast();

  const { envioCorreoCliente } = useQueryString();
  const { values, setLoading, resetLoading, setSecundario } = useLoading();
  const [pageProps, setPageProps] = useState({
    header: {
      titulo: <h4 className="titulo font-weight-bold">Compra completada</h4>,
      descripcion: <p className="descripcion">Tu plan ha sido efectuado con éxito</p>,
    },
  });

  useEffect(() => {
    if (cotizacion?.producto?.tieneFirma === '1' && cotizacion.medioFirma !== 'fisica')
      actualizarEstadoFirma();
  }, []);

  const actualizarEstadoFirma = async () => {
    const body = {
      idCotizacion,
      uniqueId: qParams.uniqueId,
      estado: qParams.accepted === 'True',
    };
    const { data: res } = await axios.post(urlActualizarEstadoFirma(), body);
    console.log('actualizarEstadoFirma', res);
    if (!res.transaccion) {
      addErrorToast(
        `${(res.errorDescripcion ?? '') || 'Hubo un error al actualizar el estado de la firma'}`,
        { autoDismiss: false },
      );
      return history.push(`/firmarCertificado/${idCotizacion}`);
    }
  };

  const { events, execEvent, isLoadingCallbacks } = usePageValidation('finCompra');

  const notificarCallback = async () => {
    setLoading(true);
    setSecundario('Estamos procesando tu compra...');
    await POST(urlIngresarPoliza(idCotizacion));
    const { data } = await POST(
      `${UrlBase}frontend/web/index.php?r=plugin/cotizacion/notificar&idCotizacion=${idCotizacion}`,
    );
    guardarLead(idCotizacion, `FIN_COMPRA__RESPUESTA_CALLBACK__${JSON.stringify(data)}`);
    resetLoading();
  };

  const init = useCallback(async () => {
    // if (!isLoadingCallbacks) {
    //   await execEvent('initCallback', { pageProps, setPageProps }, async () => {
    //     guardarLead(idCotizacion, `FIN_COMPRA__INGRESO`);
    //     if (!envioCorreoCliente) {
    //       if (cotizacion?.procesos?.notificarFinCompra) {
    //         guardarLead(idCotizacion, `FIN_COMPRA__NOTIFICO_FIN_COMPRA`);
    //         if (!qParams.isAgente) notificarFinCompra(idCotizacion);
    //       }
    //       notificarCallback();
    //     }
    //   });
    // }
    if (!isLoadingCallbacks) {
      await execEvent('initCallback', { pageProps, setPageProps }, async () => {
        guardarLead(idCotizacion, `FIN_COMPRA__INGRESO`);
        if (!envioCorreoCliente) {
          await notificarCallback();
          if (cotizacion?.producto?.segEnviarEmail == "1") {
            guardarLead(idCotizacion, `FIN_COMPRA__NOTIFICO_FIN_COMPRA`);
            if (!qParams.isAgente) notificarFinCompra(idCotizacion);
          }
        }
      });
    }
  }, [isLoadingCallbacks]);

  useEffect(() => {
    if (isLoadingCallbacks) return;
    init();
  }, [isLoadingCallbacks]);

  const onClickGoHome = async () => {
    if (!!cotizacion?.producto?.urlRetorno)
      return (window.location.href = cotizacion.producto.urlRetorno);

    setLoading(true);
    setSecundario('Espere por favor...');
    const body = { idCotizacion };

    guardarLead(idCotizacion, `FIN_COMPRA__GENERO_OTRA_COTIZACION`);
    const res = await POST(urlGenerarOtraCotizacion, body);

    if (res.transaccion) {
      window.location.href = res.data.url;
    }
  };

  const incluye: boolean = ['6', '7'].includes(cotizacion.flujoPlugin);
  const textos = cotizacion?.configuracion?.textos?.finCompra;
  const flujo = cotizacion?.flujoPlugin;

  const periocidadPago = cotizacion?.producto?.periocidadPago;

  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="finCompra.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <HeaderPage progreso={100} />

        <div className="row justify-content-center">
          {pageProps.header && (
            <div className="col-11 col-md-6 mt-3">
              <h4 className="titulo font-weight-bold">
                {textos?.titulo || pageProps?.header?.titulo}
              </h4>
              <p>{textos?.subTitulo || pageProps?.header?.descripcion}</p>
            </div>
          )}
        </div>

        <div className="row justify-content-center">
          {incluye && (
            <React.Fragment>
              {envioCorreoCliente === 'true' ? (
                <InfoCompra label="Se ha enviado el correo al cliente para que complete el proceso de registro de la tarjeta" />
              ) : (
                <InfoCompra
                  label={
                    cotizacion.metodosPago === 'externa'
                      ? 'Finalizaste tu proceso de compra exitosamente'
                      : 'Cobro prueba '
                  }
                  total={cotizacion.metodosPago === 'externa' ? '' : '1'}
                  periocidadPago={
                    cotizacion.metodosPago !== 'externa' &&
                    'El cobro realizado sera reversado de forma automatica'
                  }
                />
              )}
            </React.Fragment>
          )}

          {incluye ? (
            <React.Fragment>
              {cotizacion.formPagoSeleccionada === 'PTP' && envioCorreoCliente !== 'true' && (
                <div className="col-10 col-sm-8 text-center mb-5">
                  <h6 className="font-weight-bold text-secondary text-center">
                    Resultado: APROBADO
                  </h6>
                  <h6 className="font-weight-bold text-secondary text-center">
                    Referencia: {idCotizacion}
                  </h6>
                </div>
              )}
            </React.Fragment>
          ) : (
            <InfoCompra
              total={cotizacion?.valoresPagar?.total}
              periocidadPago={` Pago ${periocidadPago === 'Indefinido' ? 'Recurrente' : periocidadPago
                } `}
            />
          )}
          <div className="col-10 col-sm-8 text-center">
            <h6 style={{ fontSize: '14px' }}>Felicidades, {cotizacion?.titular?.nombre1}</h6>
            {envioCorreoCliente !== 'true' ||
              (cotizacion.formPagoSeleccionada === 'PTP' && <p>Gracias por preferirnos</p>)}
            {cotizacion.formPagoSeleccionada === 'PTP' && (
              <BtnPrincipal
                label="Mis pagos"
                onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)}
              />
            )}
          </div>
        </div>
        {(flujo === '1' ||
          flujo === '24' ||
          !!cotizacion?.producto?.urlRetorno ||
          (cotizacion?.producto?.tieneInicioSesion === '1' && cotizacion?.producto?.urlRetorno != "")) && (
            <FooterButton label="Ir al inicio" onClick={onClickGoHome} />
          )}
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(NewFinCompra);
